var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 33,
    viewBox: "0 0 23 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("rect", {
    y: 27.8315,
    width: 29.592,
    height: 12.6,
    transform: "rotate(-69.2156 0 27.8315)",
    fill: "#AC5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08545 29.0022L14 1.30444",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97559 31.238L19 3.30444",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45557 23.9978L13.2356 28.4689",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00732 19.9077L14.7873 24.3788",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55957 15.8184L16.3396 20.2895",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 11.7283L17.8914 16.1994",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 7.63892L19.4441 12.11",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21631 3.54907L20.9963 8.0202",
    stroke: "#FFF0FF",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.2f5c5869234ddf42380a9ca1401dc464.svg";
export { ForwardRef as ReactComponent };